import iconService from './FileExtensionIconService';

const documentTypeIconService = {
  install: (Vue) => {
    Vue.prototype.$iconService = iconService;
  },
};

export default documentTypeIconService;
